import { createSlice } from "@reduxjs/toolkit";

export const payrollSlice = createSlice({
  name: "payRoll",
  initialState: {
    loading: false,
    error: null,
    payroll: {},
    empPayConfigMain: [], //payroll
    salaryPayConfig: {},
    empPayConfig: {},
    empDeduction: {},
    empOtherPayments: {},
    currentPayrollEditing: {},
    totalAmount: 0.0,
  },
  reducers: {
    setCurrentPayrollEditing(state, action) {
      state.currentPayrollEditing = {
        ...state.currentPayrollEditing,
        ...action.payload,
      };
    },
    clearCurrentPayrollEditing(state) {
      state.currentPayrollEditing = {};
    },
    clearEmpPayConfigMain(state) {
      state.loading = false;
      state.error = null;
      state.empPayConfigMain = {};
    },
    getAllEmpPayConfigsStart(state, action) {
      state.loading = true;
      state.error = null;
    },
    getAllEmpPayConfigsSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.empPayConfigMain = action.payload;
    },
    getAllEmpPayConfigsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearPayroll(state) {
      state.loading = false;
      state.error = null;
      state.payroll = {};
    },
    getAllPayrollStart(state, action) {
      state.loading = true;
      state.error = null;
    },
    getAllPayrollSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.payroll = action.payload;
    },
    getAllPayrollFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    getAllSalaryPayConfig(state, action) {
      state.loading = true;
      state.error = null;
    },
    getAllSalaryPayConfigSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.salaryPayConfig = action.payload;
    },
    getAllSalaryPayConfigFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addNewSalaryPayConfig(state, action) {
      state.loading = true;
      state.error = null;
    },
    getCurrentEmployeePayConfig(state, action) {
      state.loading = true;
      state.error = null;
      state.empPayConfig = {};
    },
    successCurrentEmployeePayConfig(state, action) {
      state.loading = false;
      state.error = null;
      state.empPayConfig = action.payload;
    },
    addEmployeePayConfigure(state, action) {
      state.loading = true;
      state.error = null;
    },
    addDeductionStart(state, action) {
      console.log("----");
      state.loading = true;
      state.error = null;
    },
    successAddDeduction(state, action) {
      state.loading = false;
      state.error = null;
    },
    failureAddDeduction(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getAllEmpDeductions(state, action) {
      state.loading = true;
      state.error = null;
    },
    failureGetAllDeductions(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.empDeduction = {};
    },
    successGetAllDeductions(state, action) {
      (state.loading = false), (state.empDeduction = action.payload);
    },
    getAllEmpOtherPayments(state, action) {
      state.loading = true;
      state.error = null;
    },
    successGetAllEmpOtherPayments(state, action) {
      state.loading = false;
      state.error = null;
      state.empOtherPayments = action.payload;
    },
    failureGetAlllEmpOtherPayments(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.empOtherPayments = {};
    },
    addOtherPaymentsStart(state, action) {
      state.loading = true;
      state.error = null;
    },
    updateOtherPaymentsStart(state,action){
       state.loading = true;
      state.error = null;
    },
    updateOtherPaymentsFailure(state,action){
    state.loading=false;
    state.error=action.payload
    },
    failureOtherPaymentsStart(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updatePayrollStart(state,action){
      state.loading=true;
      state.error=null
    },
        updatePayrollSuccess(state,action){
      state.loading=false;
      state.error=null
    },
    failUpdatePayroll(state,action){
      state.loading=false;
      state.error=action.payload
    }
    /////////////////////////////////
  },
});

export const {
  clearPayroll,
  getAllPayrollStart,
  getAllPayrollSuccess,
  getAllPayrollFailure,
  setCurrentPayrollEditing,
  clearCurrentPayrollEditing,
  clearEmpPayConfigMain,
  getAllEmpPayConfigsStart,
  getAllEmpPayConfigsSuccess,
  getAllEmpPayConfigsFailure,
  getAllSalaryPayConfig,
  getAllSalaryPayConfigSuccess,
  getAllSalaryPayConfigFailure,
  addNewSalaryPayConfig,
  getCurrentEmployeePayConfig,
  successCurrentEmployeePayConfig,
  addEmployeePayConfigure,
  addDeductionStart,
  successAddDeduction,
  failureAddDeduction,
  getAllEmpDeductions,
  failureGetAllDeductions,
  successGetAllDeductions,
  getAllEmpOtherPayments,
  successGetAllEmpOtherPayments,
  failureGetAlllEmpOtherPayments,
  addOtherPaymentsStart,
  failureOtherPaymentsStart,
  updatePayrollStart,
  updatePayrollSuccess,
  failUpdatePayroll,
  updateOtherPaymentsStart,
  updateOtherPaymentsFailure,
} = payrollSlice.actions;

export default payrollSlice.reducer;
